// --- components/horseDetails/HorsePedigree.jsx ---
import React from 'react';

export default function HorsePedigree({ pedigree }) {
  if (!pedigree || pedigree.length === 0) return null;

  return (
    <div className="mt-5 p-3 font-montserrat shadow text-text">
      <h2 className="text-xl font-bold mb-2">Pedigree</h2>
      <ul className="list-disc pl-5">
        {pedigree.map((entry, i) => (
          <li key={i} className="py-2">
            <strong>{entry.relation}:</strong> {entry.name || 'Unknown'}
          </li>
        ))}
      </ul>
    </div>
  );
}